export const querySizeMappings = {
	"2xs": 25,
	xs: 31.25,
	sm: 40,
	md: 48,
	lg: 64,
	"2lg": 68.75,
	xl: 80,
	"2xl": 96,
	"3xl": 120,
} satisfies Record<string, number>;
